import api from '../api.js';

export const tyraRequests = {
  getAllByMonthAndYear: (month, year) => {
    return api.get(`/tyras/filter?month=${month}&year=${year}`, { cache: 'no-store' });
  },
  getById: (id) => {
    return api.get(`/tyras/${id}`, { cache: 'no-store' });
  },
  create: (tyraDto) => {
    return api.post(`/tyras`, tyraDto);
  },
  update: (tyraDto, id) => {
    return api.put(`/tyras/${id}`, tyraDto);
  },
  delete: (id) => {
    return api.delete(`/tyras/${id}`);
  },
};

export default tyraRequests;
